var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TOOL_TYPE } from '@syllepsis/editor';
import { isMatchObject } from '@syllepsis/plugin-basic';
import cls from 'classnames';
import React from 'react';
import { Icons, ListItem } from '../../../component';
import { ToolDisplay } from '../utils';
import { SelectBase } from './base';
import { getConfigVal } from './button';
var SelectForToolbar = /** @class */ (function (_super) {
    __extends(SelectForToolbar, _super);
    function SelectForToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isActive = false;
        _this.activeIdx = -1;
        _this.checkActive = function () {
            var value = _this.props.toolbar.value;
            _this.activeIdx = value.findIndex(function (_a) {
                var attrs = _a.attrs;
                return isMatchObject(attrs, _this.attrs);
            });
            var needActive = value[_this.activeIdx] && value[_this.activeIdx].needActive;
            if (!_this.attrs) {
                // needs highlight even the `attrs` is false
                if (needActive)
                    return true;
                else {
                    _this.activeIdx = -1;
                    return false;
                }
            }
            // by default, the first value of values is the default value
            if (!_this.activeIdx && (needActive || _this.props.type === TOOL_TYPE.DROPDOWN)) {
                return true;
            }
            else if (_this.activeIdx > 0) {
                return true;
            }
            return false;
        };
        _this.renderIcon = function () {
            var _a = _this.props, type = _a.type, display = _a.display, toolbar = _a.toolbar;
            var icon = type === TOOL_TYPE.SELECT ? _this.renderSelectIcon() : _this.renderDropDownIcon();
            if (display === ToolDisplay.HORIZON && toolbar.showName) {
                return (React.createElement(React.Fragment, null,
                    icon,
                    React.createElement("span", { className: "tool-value" }, toolbar.showName)));
            }
            return icon;
        };
        _this.renderSelectIcon = function () {
            var _a = _this.props, toolbar = _a.toolbar, editor = _a.editor, toolbarType = _a.toolbarType;
            if (typeof toolbar.icon === 'function')
                return toolbar.icon(editor, _this.attrs, { toolbarType: toolbarType });
            if (_this.activeIdx < 0)
                return _this.defaultIcon;
            return _this.renderMenuItem(toolbar.value[_this.activeIdx], _this.activeIdx) || _this.defaultIcon;
        };
        _this.renderDropDownIcon = function () { return _this.defaultIcon; };
        _this.renderMenuItem = function (value, idx) {
            if (idx === void 0) { idx = 0; }
            var name = _this.props.name;
            if (value.render) {
                return value.render({ toolbarType: _this.props.toolbarType });
            }
            else if (value.icon !== undefined) {
                return (React.createElement(React.Fragment, null,
                    value.icon,
                    React.createElement("span", { className: "tool-value" }, value.text)));
            }
            else if (value.text !== undefined) {
                return React.createElement("span", { className: "tool-value" }, value.text);
            }
            else if (Icons[name] && Icons[name][idx]) {
                return Icons[name][idx];
            }
        };
        _this.menuItemClick = function (attrs) {
            _this.closeMenu();
            _this.props.handler(_this.props.editor, _this.props.name, attrs);
        };
        _this.renderMenu = function () {
            var _a = _this.props, value = _a.toolbar.value, _b = _a.toolbarType, toolbarType = _b === void 0 ? 'static' : _b;
            return value.map(function (v, index) {
                var _a;
                return (React.createElement(ListItem, { className: cls((_a = {
                            active: index === _this.activeIdx
                        },
                        _a[toolbarType] = toolbarType,
                        _a)), key: JSON.stringify(v.attrs), onClick: function () { return _this.menuItemClick(v.attrs); } }, _this.renderMenuItem(v, index)));
            });
        };
        return _this;
    }
    SelectForToolbar.prototype.componentDidMount = function () {
        this.props.editor.configurator.on(this.props.groupKey + "-close", this.closeMenu);
    };
    SelectForToolbar.prototype.componentWillUnmount = function () {
        this.props.editor.configurator.off(this.props.groupKey + "-close", this.closeMenu);
    };
    Object.defineProperty(SelectForToolbar.prototype, "attrs", {
        get: function () {
            var _a = this.props, getAttrs = _a.toolbar.getAttrs, attrs = _a.attrs, editor = _a.editor;
            return getAttrs ? getAttrs(editor) : attrs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectForToolbar.prototype, "defaultIcon", {
        get: function () {
            var _a = this.props, _b = _a.toolbar, icon = _b.icon, value = _b.value, name = _a.name, type = _a.type, editor = _a.editor;
            if (icon) {
                if (typeof icon === 'function')
                    return icon(editor, this.attrs);
                var defaultIdx = value.findIndex(function (item) { return item.default; });
                if (value[defaultIdx] && value[defaultIdx].icon)
                    return value[defaultIdx].icon;
                return icon;
            }
            var Icon = Icons[name];
            if (type === TOOL_TYPE.SELECT) {
                return Icon && Icon[0];
            }
            return Icon;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectForToolbar.prototype, "showName", {
        get: function () {
            return getConfigVal([this.props.showName, this.props.toolbar.showName]);
        },
        enumerable: false,
        configurable: true
    });
    return SelectForToolbar;
}(SelectBase));
export { SelectForToolbar };
//# sourceMappingURL=select.js.map